import React from 'react'
import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import Header, { ImageWrap, TextWrap } from './Header'
import Item, { List } from './Item'
import magnifier from './magnifier.png'
import magnifier2x from './magnifier@2x.png'
import Link from 'streamr-ui/Link'

function ExternalLink({ node, ...props }) {
    return <Link {...props} blank />
}

function Md({ children }) {
    return (
        <ReactMarkdown
            components={{
                a: ExternalLink,
            }}
        >
            {children}
        </ReactMarkdown>
    )
}

function UnstyledFaq(props) {
    return (
        <div {...props}>
            <div>
                <Header $appear>
                    <div>
                        <TextWrap>
                            <h2 $appear>Frequently Asked Questions</h2>
                        </TextWrap>
                        <ImageWrap>
                            <img $appear src={magnifier} srcSet={`${magnifier2x} 2x`} alt="" />
                        </ImageWrap>
                    </div>
                </Header>
                <List $appearIntersection>
                    <Item
                        openOnMount
                        question={
                            <>What is Streamr Network?</>
                        }
                    >
                        <p>
                            Streamr provides the real-time data infrastructure of the decentralised
                            web (Web3). Streamr technology is a core service layer which implements
                            an open-source and vendor-neutral publish/subscribe (pub-sub) protocol
                            for transmission of real-time data. The data travels via a global
                            peer-to-peer network, which is scalable, robust, permissionless,
                            and secured by&nbsp;cryptography.
                        </p>
                        <p>
                            The technology works in tandem with companion blockchains - currently
                            Ethereum, Gnosis, and Polygon - which are used for identity, security,
                            and payments. On top of the network is the application layer, including
                            The Hub and all third party&nbsp;applications.
                        </p>
                        <p>
                            The DATA token is an ERC-20 token used for project governance,
                            to incentivise the Network participants, and to delegate stake on Streamr
                            nodes.
                        </p>
                    </Item>
                    <Item
                        question={
                            <>What problem does Streamr solve?</>
                        }
                    >
                        <p>
                            As our connected world creates and consumes more and more data, it has
                            not been possible to connect the billions of devices worldwide with
                            real-time data via a decentralised network. Meanwhile, today&apos;s
                            existing centralised services are subject to a single point of failure
                            and vendor lock&nbsp;in.
                        </p>
                        <p>
                            Streamr solves these problems by delivering a low latency and secure
                            decentralised broadcast messaging protocol - via a peer to peer (P2P)
                            network architecture. Thanks to this P2P architecture - the network is
                            fault tolerant, resilient to malicious attacks and scales in line with
                            the growth of the network - for scalable many to many real time
                            data&nbsp;pipelines.
                        </p>
                    </Item>
                    <Item
                        question={
                            <>When was Streamr started?</>
                        }
                    >
                        <p>
                            The Streamr project was started in 2017 by Henri&nbsp;Pihkala, Nikke&nbsp;Nylund,
                            Risto&nbsp;Karjalainen and Michael&nbsp;Malka.
                        </p>
                    </Item>
                    <Item
                        question={
                            <>Who is building Streamr?</>
                        }
                    >
                        <p>
                            Streamr is a distributed open-source software project with around 30 key
                            contributors around the world, including both companies
                            and&nbsp;individuals.
                        </p>
                        <Md>
                            Key decisions in the project are made via [governance voting](https://vote.streamr.network)
                            using DATA&nbsp;tokens.
                        </Md>
                    </Item>
                    <Item
                        question={
                            <>Where can I find the latest Streamr news?</>
                        }
                    >
                        <Md>
                            We publish updates about Streamr, the ecosystem, node running, and other
                            happenings from the project on the
                            [Streamr blog](https://blog.streamr.network/tag/news/),
                            [Twitter](https://twitter.com/streamr),
                            [LinkedIn](https://www.linkedin.com/company/streamr-network/),
                            [YouTube](https://www.youtube.com/c/Streamr),
                            [Telegram (announcements only)](https://t.me/streamrofficial),
                            and [Discord&nbsp;community](https://discord.gg/streamr).
                        </Md>
                        <p>
                            You can also sign up for our newsletter to receive important updates
                            directly in your&nbsp;inbox.
                        </p>
                    </Item>
                </List>
            </div>
        </div>
    )
}

const Faq = styled(UnstyledFaq)`
    box-sizing: border-box;
    font-family: 'IBM Plex Sans', sans-serif;
    color: #0c009a;
    padding: 0 18px;

    > div {
        max-width: 704px;
        margin: 0 auto;
    }

    @media (min-width: 768px) {
        padding: 0 32px;

        > div {
            max-width: 896px;
        }
    }

    @media (min-width: 1216px) {
        padding: 0 160px;

        > div {
            box-sizing: border-box;
            display: flex;
            max-width: 1160px;
        }
    }
`

export default Faq
